module.exports = __webpack_public_path__ + "media/assets/img/flags/en-JM-7748ab6243c869a8359a5e92837fd5ad.png";